/* eslint-disable i18next/no-literal-string */
import {Table} from '@dropbox/dig-components/table';
import cx from 'classnames';
import type {AskHealthWeek} from 'client';
import {Layout} from 'components/DSYS/Layout';

import styles from './AskHealth.module.css';
import {percent, seconds, weekLabel} from './format';

type Column = {header: string; cell: (week: AskHealthWeek) => string | number};

const COLUMNS: Column[] = [
  {header: 'Week of', cell: weekLabel},
  {header: 'Questions', cell: (w) => w.questions},
  {header: 'Answered', cell: (w) => percent(w.answered)},
  {header: 'Gaps', cell: (w) => percent(w.answer_gap)},
  {header: 'Errors', cell: (w) => percent(w.error)},
  {header: 'Gave up', cell: (w) => percent(w.abandoned)},
  {header: 'Median', cell: (w) => seconds(w.median_seconds)},
  {header: 'Slowest 10%', cell: (w) => seconds(w.p90_seconds)},
  {header: 'Dash agent', cell: (w) => percent(w.dash_agent)},
  {header: 'Dash rescues', cell: (w) => w.dash_rescued ?? 0},
  {header: 'Quality', cell: (w) => percent(w.quality)},
  {header: 'Scored', cell: (w) => w.scored ?? 0},
];

/** Newest week first. Wider than the column: it breaks out on both sides. */
export const WeeksTable = ({weeks}: {weeks: AskHealthWeek[]}) => (
  <div className={cx(styles.tableScroll, Layout.breakoutWideClassName)}>
    <Table>
      <Table.Header>
        <Table.Row>
          {COLUMNS.map((column) => (
            <Table.HeaderCell key={column.header} className={styles.nowrap}>
              {column.header}
            </Table.HeaderCell>
          ))}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {[...weeks].reverse().map((week) => (
          <Table.Row key={week.start}>
            {COLUMNS.map((column) => (
              <Table.Cell key={column.header} className={styles.nowrap}>
                {column.cell(week)}
              </Table.Cell>
            ))}
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  </div>
);
